'use client';

import { Button } from '@florencelabs/button';
import { FC, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHydratedDesktop } from '@provider-directory/hooks/useHydratedDesktop';
import { InsuranceCarrier } from '@provider-directory/types';
import { InsuranceCarrierItem } from './insurance-carrier-item.component';

const MOBILE_VISIBLE_CARRIERS = 8;

interface InsuranceCarrierListProps {
  carriers: InsuranceCarrier[];
}

export const InsuranceCarrierList: FC<InsuranceCarrierListProps> = ({
  carriers,
}) => {
  const [seeMore, setSeeMore] = useState(false);
  const isDesktop = useHydratedDesktop();
  const { t } = useTranslation();

  const [columns, displayedCarriers] = useMemo(() => {
    const numColumns = 2;
    const numRows = Math.ceil(carriers.length / numColumns);

    const cols = Array.from({ length: numColumns }, (_, colIndex) =>
      carriers.filter(
        (_item, index) => Math.floor(index / numRows) === colIndex,
      ),
    );

    const flattened = cols.flat();
    const displayed = seeMore
      ? flattened
      : flattened.slice(0, MOBILE_VISIBLE_CARRIERS);
    return [cols, displayed];
  }, [carriers, seeMore]);

  return (
    <div className={'grid grid-cols-1 gap-x-3 desktop:grid-cols-2'}>
      {isDesktop ? (
        <>
          {columns.map((column, colIndex) => (
            <div key={colIndex} className={'flex flex-col'}>
              {column.map((carrier) => (
                <InsuranceCarrierItem key={carrier.name} carrier={carrier} />
              ))}
            </div>
          ))}
        </>
      ) : (
        <>
          {displayedCarriers.map((carrier) => (
            <InsuranceCarrierItem key={carrier.name} carrier={carrier} />
          ))}
        </>
      )}

      {!isDesktop && carriers.length > MOBILE_VISIBLE_CARRIERS && (
        <Button
          className={'inline-block w-fit px-0 !pt-5'}
          variant={'clientEmpty'}
          onPress={() => {
            setSeeMore((prev) => !prev);
          }}
        >
          {seeMore
            ? t('details.showLessInsurance')
            : t('details.showMoreInsurance')}
        </Button>
      )}
    </div>
  );
};
